import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Badge = styled.span.withConfig({
  displayName: "partials__Badge",
  componentId: "sc-yutzui-0"
})(["align-items:center;padding:4px 6px;border-radius:", ";margin:4px;background-color:", ";font-size:18px;font-weight:600;line-height:1;"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme,
    value = _ref2.value,
    max = _ref2.max;
  return value < max ? theme.colors.positiveL : theme.colors.negativeL;
});
export var FieldsCount = styled.span.withConfig({
  displayName: "partials__FieldsCount",
  componentId: "sc-yutzui-1"
})(["align-self:self-end;margin:0 auto;margin-top:30px;font-size:17px;font-weight:550;"]);
export var Block = styled.div.withConfig({
  displayName: "partials__Block",
  componentId: "sc-yutzui-2"
})(["display:grid;grid-template-columns:2fr 5fr;padding:9px 0;&:not(:last-child){border-bottom:1px solid ", ";}", ";> div{&:nth-child(2){text-align:right;", ";}}h6{margin-right:9px;font-weight:500;", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiL;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n    text-align: left;\n  "]))), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      text-align: left;\n      "]))), maxMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-right: 0;\n      margin-bottom: 10px;\n      font-weight: 600;\n    "]))));
export var BodyInner = styled.div.withConfig({
  displayName: "partials__BodyInner",
  componentId: "sc-yutzui-3"
})(["overflow:scroll;padding-right:8px;"]);